import { useLoaderData } from "@tanstack/react-router";

export default function useClientInfos() {
	try {
		const data = useLoaderData({ from: "/app/_layout" });
		return data.client;
	} catch (e) {
		return null;
	}
}
